import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { map } from 'lodash'

import StoreContext from 'context/Store'

import {
  ButtonDecorated
} from 'components/Typography'

import {
 SORT_OPTIONS
} from 'constants/collection'

const Wrapper = styled.div`
  position: relative;  
  user-select: none;
  margin: 7px 0 0 30px;
`

const Label = styled.button`
  height: calc(100% - 5px);
  white-space: nowrap;
  span:nth-child(1) {
    text-transform: uppercase;
    ${p => p.theme.typography.tNormal};
  }

  span {
    ${p => p.theme.typography.tSmall};
  }

  i {
    margin: 0 0 0 10px;
  }

  span, i {
    display: inline-block;
    vertical-align: middle;
  }
`

const Dropdown = styled.div`
  position: absolute;
  right: 0;
  display: ${p => p.open ? 'flex' : 'none'};
  background-color: ${p => p.theme.colors.green};
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 5px 24px 10px 40px;
`

const DropdownItem = styled(ButtonDecorated)`
  ${p => p.theme.typography.tSmall};
  margin: 0 0 12px 0;
  line-height: 1em;
  white-space: nowrap;
`

const SortDropdown = ({ className }) => {
  const { collection: {
    sort,
    setSort
  }} = useContext(StoreContext)
  const [open, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!open)
  }

  const onMouseLeave = () => {
    setOpen(false)
  }

  const onClick = sort => {
    setOpen(false)
    setSort(sort)
  }
  
  return (
    <Wrapper onMouseLeave={onMouseLeave} className={className}>
      <Label onClick={toggleOpen}>
        <span>Sort: </span> <span>{SORT_OPTIONS[sort] || SORT_OPTIONS['latest']}</span>
        <i className={`icon-chevron-${open ? 'up' : 'down'}`}></i>
      </Label>
      <Dropdown open={open}>
        {map(SORT_OPTIONS, (v, k) => (
           <DropdownItem
               key={k}
               className={k === sort && 'is-active'}
               onClick={() => onClick(k)}>
             {v}
           </DropdownItem>
         ))}
      </Dropdown>
    </Wrapper>
  )
}

export default SortDropdown
